function createAuthActions({
  apiFetch,
  setAuthToken,
  setWorkspaceReady,
  setCurrentUser,
  setCompanies,
  setTemplates,
  setUsers,
  setApprovals,
  setBatches,
}) {
  const login = async (email, password) => {
    const payload = await apiFetch('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }, '');
    setWorkspaceReady(false);
    setAuthToken(payload.token);
    return payload;
  };

  const logout = async () => {
    try {
      await apiFetch('/api/auth/logout', { method: 'POST' });
    } catch (_) {
      // keep local logout even if API fails
    }
    setAuthToken('');
    setCurrentUser({ id: null, name: 'Usuário', role: 'Perfil', email: '', permissions: [], debug_enabled: 'N' });
    setCompanies([]);
    setTemplates([]);
    setUsers([]);
    setApprovals([]);
    setBatches([]);
  };

  return { login, logout };
}

export { createAuthActions };
